import { motion } from "framer-motion";
import { useI18n } from "@/lib/i18n";

const fadeUp = {
  hidden: { opacity: 0, y: 24 },
  show: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.9, delay: i * 0.12, ease: [0.16, 1, 0.3, 1] },
  }),
};

export default function Pillars() {
  const { t } = useI18n();
  return (
    <section
      id="pillars"
      className="bg-ink-900 text-sand-50 py-24 md:py-32 lg:py-40"
      data-testid="pillars-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-sand-50/10">
          {t.pillars.map((p, i) => (
            <motion.article
              key={p.title}
              custom={i}
              variants={fadeUp}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, margin: "-80px" }}
              className="bg-ink-900 p-10 md:p-14 lg:p-16 flex flex-col gap-8 min-h-[320px]"
              data-testid={`pillar-${i}`}
            >
              <span className="text-[10px] tracking-[0.4em] uppercase text-gold">
                {p.kicker}
              </span>
              <h3 className="font-serif font-light text-3xl md:text-4xl leading-[1.1] tracking-tight">
                {p.title}
              </h3>
              <p className="text-sm md:text-base text-sand-50/65 leading-relaxed max-w-sm mt-auto">
                {p.body}
              </p>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
